import { render } from "./report-dataset.vue?vue&type=template&id=08b2a54e"
import script from "./report-dataset.vue?vue&type=script&lang=js"
export * from "./report-dataset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__